import dynamic from "next/dynamic";

export const DynamicHomeHeaderAvatar = dynamic(() =>
  import("scmp-app/components/home/header/header-avatar").then(module => module.HomeHeaderAvatar),
);

export const DynamicHomeNewsTicker = dynamic<Record<string, never>>(() =>
  import("scmp-app/components/home/news-ticker").then(module => module.HomeNewsTicker),
);
